
<div style="width: 100%; text-align: center;">
    <mat-select [(ngModel)]="intIdExplotacion" name="intIdExplotacion"  (selectionChange)="selectExplotacion()"  placeholder="Explotacion">
        <mat-option name="intIdExplotacion" [value]="1">Explotacion 1</mat-option>
        <mat-option name="intIdExplotacion" [value]="2">Explotacion 2</mat-option>
      </mat-select>
</div>

<br><br>

<div style="width: 100;; text-align: center; color: red; font-weight: 600;" *ngIf="isSelected">
Por favor, seleccione una explotación
</div>
<br *ngIf="isSelected">

<div class="form-actions">
    <div class="text-right">
      <button mat-raised-button (click)="guardar()" class="btn-confirm">Guardar</button>
      <button mat-raised-button (click)="cancelar()" class="btn-cancel">Cancelar</button>
    </div>
  </div>